var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(_vm.label))]),_vm._l((_vm.options),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.text))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }